var exports = {
  "w": "Footer__ceP2tg",
};

module.exports = exports;
